export default __webpack_public_path__ + "static/media/ProjetAzimuto.d7b5f741.pdf";